// ===========================================
// PUSH REGISTRATION (APNs via Capacitor)
// ===========================================
// On a native iOS build with a signed-in session, ask permission once, register
// with APNs, and hand the device token to the API (tenant-scoped registry).
// On web or without a session this is a silent no-op.

import { Capacitor } from '@capacitor/core';

const APP_ID = 'com.mise.pos';
const API_BASE = (import.meta as any).env?.VITE_API_URL || '/api';

function getJwt(): string | null {
  try { return JSON.parse(localStorage.getItem('mise-pos-auth') || '{}')?.state?.token || null; } catch { return null; }
}

let armed = false;
export function armPushRegistration() {
  if (armed || Capacitor.getPlatform() !== 'ios') return;
  armed = true;
  const attempt = async (): Promise<boolean> => {
    const jwt = getJwt();
    if (!jwt) return false; // not signed in yet - try again shortly
    try {
      const { PushNotifications } = await import('@capacitor/push-notifications');
      const perm = await PushNotifications.requestPermissions();
      if (perm.receive !== 'granted') return true; // user said no - respect it
      await new Promise<void>((resolve) => {
        PushNotifications.addListener('registration', async (t) => {
          try {
            await fetch(`${API_BASE}/v1/push/register`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getJwt()}` },
              body: JSON.stringify({ token: t.value, appId: APP_ID, platform: 'ios' }),
            });
          } catch { /* registry retry next launch */ }
          resolve();
        });
        PushNotifications.addListener('registrationError', () => resolve());
        PushNotifications.register();
      });
      return true;
    } catch { return true; } // plugin unavailable (old build) - stop quietly
  };
  (async () => {
    for (let i = 0; i < 40; i++) {
      if (await attempt()) return;
      await new Promise((r) => setTimeout(r, 15000)); // wait for login
    }
  })();
}
